import { ChevronDown16 } from '@carbon/icons-react';
import { BriefcaseIcon } from '@primer/octicons-react';
import { ModelEntityType } from '@upright/common/model/input/types';
import {
  MANAGE_ACCESS_PATH,
  SCREEN_COMPANIES_PATH,
  SCREEN_FUNDS_PATH,
} from '@upright/ui/common/generic/components/navigation/page-paths';
import { NavLinkType } from '@upright/ui/common/generic/content/texts/bou-link/types';
import { getModelEntitySvgIcon } from '@upright/ui/common/generic/global/model-entity-icons';
import { useIsClientOrTeamOrFreeTrial } from '@upright/ui/common/generic/hooks';
import { useTheme } from '@upright/ui/common/generic/theme/custom-theme';
import { usePushGtmEvent } from '../../../../google-tag-manager/use-push-gtm-event';
import { CustomGtmEvent } from '../../../../google-tag-manager/use-push-gtm-event/payloads';
import { MenuLink } from '../nav-menu/radix-nav-link';
import {
  Arrow,
  ContentList,
  ListItem,
  ListItemInner,
  MenuContent,
  MenuItemTriggerWrapper,
  MenuList,
  MenuRoot,
  MenuTrigger,
  MenuViewport,
  StyledIndicator,
} from '../shared';

export const ToolsMenu = () => {
  const pushGtmEvent = usePushGtmEvent();
  const isClientOrTeam = useIsClientOrTeamOrFreeTrial();
  const theme = useTheme().theme;

  const CompanyEntityIcon = getModelEntitySvgIcon(ModelEntityType.COMPANY);
  const GroupEntityIcon = getModelEntitySvgIcon(ModelEntityType.GROUP);

  return (
    <MenuRoot delayDuration={0}>
      <MenuList>
        <MenuItemTriggerWrapper>
          <MenuTrigger>
            <span>Tools</span>
            <ChevronDown16 />
          </MenuTrigger>
          <MenuContent>
            <ContentList>
              <ListItem
                onClick={() => {
                  pushGtmEvent({
                    event: CustomGtmEvent.ADVANCED_SCREENER_CLICK,
                  });
                }}
              >
                <MenuLink to={SCREEN_COMPANIES_PATH} linkType={NavLinkType.INTERNAL}>
                  <ListItemInner>
                    <CompanyEntityIcon color={theme?.colors.icon.grayOnDarkBg} width={16} height={16} />
                    <span>Screen companies</span>
                  </ListItemInner>
                </MenuLink>
              </ListItem>
              <ListItem>
                <MenuLink to={SCREEN_FUNDS_PATH} linkType={NavLinkType.INTERNAL}>
                  <ListItemInner>
                    <GroupEntityIcon color={theme?.colors.icon.grayOnDarkBg} width={16} height={16} />
                    <span>Screen funds</span>
                  </ListItemInner>
                </MenuLink>
              </ListItem>
              <ListItem>{isClientOrTeam ? <MyAssetsLink /> : <PortfolioBuilderLink />}</ListItem>
            </ContentList>
          </MenuContent>
        </MenuItemTriggerWrapper>
        <StyledIndicator>
          <Arrow />
        </StyledIndicator>
      </MenuList>
      <MenuViewport />
    </MenuRoot>
  );
};

const PortfolioBuilderLink = () => {
  const theme = useTheme().theme;
  return (
    <MenuLink to="/my-portfolios" linkType={NavLinkType.INTERNAL}>
      <ListItemInner>
        <BriefcaseIcon fill={theme?.colors.icon.grayOnDarkBg} size={16} />
        <span>Build a portfolio</span>
      </ListItemInner>
    </MenuLink>
  );
};

const MyAssetsLink = () => {
  const theme = useTheme().theme;
  return (
    <MenuLink to={MANAGE_ACCESS_PATH} linkType={NavLinkType.INTERNAL}>
      <ListItemInner>
        <BriefcaseIcon fill={theme?.colors.icon.grayOnDarkBg} size={16} />
        <span>My assets</span>
      </ListItemInner>
    </MenuLink>
  );
};
